export const SERVICE_FEE = 5;
export const REFUND_POLICY_URL = '/refund-policy';
export const SESSION_MATERIAL_ACCEPT =
  '.pdf,.doc,.docx,.png,.jpg,.jpeg,.gif,application/pdf,image/*';

export const getSessionHours = (session) =>
  (new Date(session.end) - new Date(session.start)) / (60 * 60 * 1000);

export const getSessionPrice = (rate, session) =>
  Number(rate) * getSessionHours(session) + SERVICE_FEE;

export const formatSessionTime = (start, end) =>
  `${new Date(start).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })} - ${new Date(end).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`;

export const groupSessionsByLearner = (sessions) => {
  const map = new Map();
  sessions.forEach((session) => {
    const key = session.learnerLabel || 'Self';
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(session);
  });
  return [...map.entries()].map(([label, items]) => ({
    label,
    sessions: items.sort((a, b) => new Date(a.start) - new Date(b.start)),
  }));
};

export const groupSessionsBySubject = (sessions, rate) => {
  const map = new Map();
  sessions.forEach((session) => {
    const key = session.subjectName || `Subject ${session.subjectId}`;
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(session);
  });
  return [...map.entries()].map(([subjectName, items]) => ({
    subjectName,
    subjectId: items[0]?.subjectId,
    sessions: items.sort((a, b) => new Date(a.start) - new Date(b.start)),
    total: items.reduce((sum, session) => sum + getSessionPrice(rate, session), 0),
  }));
};

export const hasSessionMaterials = (sessionMaterials, sessionId) => {
  const entry = sessionMaterials[sessionId];
  return Boolean(entry?.files?.length || entry?.comments?.trim());
};

export const countReadySessions = (sessions, sessionMaterials) =>
  sessions.filter((session) => hasSessionMaterials(sessionMaterials, session.id)).length;

export const createEmptySessionMaterial = () => ({ files: [], comments: '' });

export const makeLocalFileEntry = (file) => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  file,
  name: file.name,
  size: file.size,
  type: file.type,
});
